import ConfigTitle from './ConfigTitle';
import MetricList from './MetricList';
import _ from 'lodash';
import validationMixin from '@/mixins/validation.mixin.js';
import { checkAccountAuth } from '../serviceApi';
import BoxRegion from './BoxRegion.vue';

let configMixin = {
  mixins: [validationMixin],
  props: {
    configItems: { type: Array, default: [] }
  },
  inject: ['mode'],
  components: { ConfigTitle, MetricList, BoxRegion },
  emits: ['changeValidate', 'configModify'],
  created() {
    let _width = this.defaultConfig.chartAttr.w;
    let _height = this.defaultConfig.chartAttr.h;
    if (this.configItems.length > 0) {
      if (this.isExternalAddMode) {
        this.defaultConfig = _.merge(this.defaultConfig, this.configItems[0]);
      } else {
        this.defaultConfig = this.configItems[0];
      }

      if (this.$util.isEmpty(this.defaultConfig.chartAttr.chartId)) {
        this.defaultConfig.chartAttr.chartId = 'widgetTmp' + Math.floor(Math.random() * 1000);
      }
      this.defaultConfig.chartAttr.w = _width;
      this.defaultConfig.chartAttr.h = _height;
      this.widgetName = this.defaultConfig.chartAttr.title;
    }

    this.initPage();
  },
  computed: {
    // 위젯 등록 여부
    isAddMode() {
      return this.mode === 'add';
    },
    // 위젯 수정 여부
    isModifyMode() {
      return this.mode === 'modify';
    },
    // 위젯 외부 등록 여부
    isExternalAddMode() {
      return this.mode === 'externalAdd';
    }
  },
  watch: {
    widgetName: _.debounce(function () {
      this.onConfigChange(false);
    }, 0)
  },
  data() {
    return {
      projectItems: [], // 프로젝트 목록
      projectModel: '', // 선택한 프로젝트
      checkCount: 0, // dirty check count
      originConfigs: [], // 위젯 기본 설정 정보,
      notObjectItems: {
        // 하위 상품이 있는 상품에 한하여 API 요청시 object 값 제외유형
        Kubernetes: ['cluster'],
        'Load Balancer': ['service'],
        DataOps: ['service'],
        DataFlow: ['service'],
        QuickQuery: ['namespace'],
        DataWrangler: ['namespace']
      },
      isAccountAuth: true,
      isChanged: false
    };
  },
  methods: {
    async initPage() {
      this.$emit('changeValidate', true);
      await this.init();
      if (this.isAddMode) {
        this.onConfigChange(false);
      }
    },
    async init() {
      if (this.defaultConfig.chartAttr.widget.type !== 'TitleBoxWidget') {
        try {
          this.isAccountAuth = await checkAccountAuth();
        } catch (error) {
          this.isAccountAuth = false;
        }
      }
      await this.setDefault(false);
      this.updateFieldsBeforeModify();
    },
    updateFieldsBeforeModify() {},
    validate() {
      return true;
    },
    setDefault() {},

    // 위젯 기본 설정 정보 셋팅
    config(obj) {
      let chartAttr = Object.assign(
        {
          title: '',
          subtitle: '',
          projectName: '',
          projectId: '',
          widget: {},
          isDraggable: true,
          isResizable: false,
          static: false,
          x: 0,
          y: 0,
          w: 2,
          h: 2,
          minW: 2,
          maxW: 2,
          minH: 2,
          maxH: 2
        },
        obj
      );
      return {
        chartId: 1,
        chartAttr: chartAttr,
        chartName: '',
        chartType: '',
        dashboardId: 1,
        fixedYn: 'N',
        snapshotYn: 'N',
        url: ''
      };
    },

    // 위젯 기본설정 정보 가져오기
    getCommonConfig() {
      let config = this.$util.deepCopy(this.defaultConfig);
      return config;
    },

    changeTitleBox(value, index) {
      if (value !== this.texts[index]) {
        this.changeData();
      }
      this.texts[index] = value;
    },
    changeWidgetName(value) {
      if (value !== this.widgetName) {
        this.widgetName = value;
        this.changeData();
      }
    },
    // 위젯명 validation
    checkWidgetName(value) {
      if (!this.checkEmpty(value)) {
        return this.$t('message.requiredInput');
      }
      if (value.length > 100) {
        return this.$t('message.inputLimit', [this.$t('label.widgetName'), '100']);
      }
      if (value.charAt(0) === '.') {
        return this.$t('message.errorValidateInput');
      }
      if (this.$util.requireInputCommon(value)) {
        return this.$t('message.errorValidateInput');
      }
      return true;
    },
    changeData() {
      this.isChanged = true;
      const check = this.validateBtnComfirm();
      this.$emit('changeValidate', check);
    },
    validateBtnComfirm() {
      if (this.checkWidgetName(this.widgetName) !== true) return true;
      return false;
    }
  }
};
export default configMixin;
